import { render } from "./ModalApprovalDelegateEditor.vue?vue&type=template&id=1e030124"
import script from "./ModalApprovalDelegateEditor.vue?vue&type=script&lang=js"
export * from "./ModalApprovalDelegateEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__